import {createSelector} from '@reduxjs/toolkit'
import { fullName } from '../../app/utils'
import {companyPeopleListSelector} from "./companyPeopleListSelector"

const workHistoryDestailsSelector = createSelector(
    [state => state.components,
        state => state.primaryAgencyApplication.application?.businessLicenceData,
        companyPeopleListSelector],
    (components, appData, peopleList) => { 

        let workHistoryList = []
        let licenceSuspendedData = []
        

        if(appData) {
            if(appData.workHistoryData)
                workHistoryList = appData.workHistoryData

            if(appData.licenceSuspendedData)
                licenceSuspendedData = appData.licenceSuspendedData
        }

        return  Object.assign({},
            components.workHistoryDetails,
            {
                workHistoryList,
                peopleList,
                licenceSuspendedData
            }
        )
    }
)

export const workHistoryDetailsSelect = state => ({
    workHistoryDetails: workHistoryDestailsSelector(state)
})

export const populateWorkHistoryListDataForReview = (workHistoryList) => { 

    if(workHistoryList && Array.isArray(workHistoryList)) {
        return workHistoryList.map((history) => { 
            let name = ''
            if(history.people) {
                name = fullName(history.people)
                let position = history.people.position
    
                if(position) {
                    name = name + ", " + position
                }
            }

            return {
                "Name" : name,
                "Work description" : history.description
            }
        })
    }

    return []
}
